const footerStrings = {
    contact: "Contact",
    info: "Info",
    other: "Other",
    address: "Address",
    phoneNumber: "Phone Number",
    menu: "Menu",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy",
    copywrite: "© 2025 by WebLords LLC | Created by Code Decoded"
};

export default footerStrings;
